import React, { useEffect, useState } from "react";
import { PiSidebarBold, PiSpinnerBallFill } from "react-icons/pi";
import { TbEdit } from "react-icons/tb";
import "./Sidebar.css";
import { isLast30Days, isLast7Days, isToday } from "../../common/common";
import Select from "react-select";

function Sidebar({ points, setSidebar, sidebar, onNewChat, history, setSelectHistory, selectHistory, selectedOption, setSelectedOption, categoryDropdown }) {

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setSidebar(window.innerWidth >= 1080);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleHide = (e) => {
    if (window.innerWidth <= 1080) {
      setSidebar(false);
    }
  };

  const handleShow = (e) => {
    e.preventDefault();
    setSidebar(true);
  };

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const formatOptions = (data) => {
    return data.map((category) => {
      if (category.SubCategories.length > 0) {
        // Group with subcategories as options
        return {
          label: category.CategoryType,
          options: category.SubCategories.map((sub) => ({
            value: `subcategory-${sub.SubCategoryID}`,
            label: sub.SubCategoryType,
            categoryId: category.CategoryID,
            SubCategoryID: sub.SubCategoryID,
            isSubcategory: true
          }))
        };
      } else {
        return {
          value: `category-${category.CategoryID}`,
          label: category.CategoryType,
          isSubcategory: false,
          categoryId: category.CategoryID,
          SubCategoryID: 0,
        };
      }
    });
  };
  const options = formatOptions(categoryDropdown);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#373333',
      color: 'white',
      borderColor: state.isFocused ? 'white' : 'gray',
      borderRadius: "8px",
      boxShadow: state.isFocused ? '0 0 0 1px white' : 'none',
      '&:hover': {
        borderColor: 'white',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#ccc',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#373333',
      color: 'white',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#444'
        : state.isFocused
          ? '#222'
          : '#373333',
      color: state.isSelected ? "#6366f1" : 'white',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#333',
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'white',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    input: (provided) => ({
      ...provided,
      color: 'white',
    }),
  };

  return (
    <>
      {!sidebar && (
        <div onClick={handleShow} >
          <PiSidebarBold className="close-window chatgpt-show" />
        </div>
      )}
      {sidebar && (
        <div className={`sidebar ${sidebar ? "active" : ""}`}>
          <div className="icons">
            <div className="left-icon tooltip-sidebar">
              <PiSidebarBold className="close-window" onClick={handleHide} />
              {window.innerWidth <= 1080 && (
                <span className="tooltip-text tooltop-left">Close sidebar</span>
              )}
            </div>
            {width <= 440 && (
              <div>
                <h5 className='m-0 sidebar-points'>Points : {points}</h5>
              </div>
            )}
            {/*<h2 style={{ margin: 0, color: "white" }}>Name</h2>*/}
            <div className="left-icon tooltip-sidebar" onClick={onNewChat}>
              <TbEdit size={24} />
              <span className="tooltip-text">New Chat</span>
            </div>

          </div>
          {width >= 440 ? (
            <div style={{ padding: "4px" }}>
              <button className="sidebar-new-chat" onClick={onNewChat}><PiSpinnerBallFill size={24} />ChatGPT</button>
            </div>
          ) : (
            <div className='sidebar-category'>
              <Select
                inputId="react-select"
                options={options}
                value={selectedOption}
                onChange={handleChange}
                placeholder="Select..."
                isClearable
                styles={customStyles}
              />
            </div>
          )}
          <div className="content">
            {history?.length > 0 && (
              <div className="sub-content">
                {history.find(item => isToday(item.date)) && (
                  <p className="f-size" style={{ fontSize: "0.8rem" }}>Today</p>
                )}
                {history.filter(item => isToday(item.date)).map((item, idx) => (
                  <p key={`today-${idx}`} className={`title-truncate ${selectHistory?.date === item?.date && selectHistory?.title && item?.title ? "select-history" : "title-truncate:hover"}`}
                    onClick={() => {
                      setSelectHistory(item);
                      if (window.innerWidth < 1080) {
                        setSidebar(false);
                      }
                    }}
                  >{item.title}</p>
                ))}

                {/* Previous 7 Days */}
                {history.find(item => isLast7Days(item.date)) && (
                  <p className="f-size" style={{ fontSize: "0.8rem" }}>Previous 7 Days</p>
                )}
                {history.filter(item => isLast7Days(item.date)).map((item, idx) => (
                  <p key={`last7-${idx}`} className={`title-truncate ${selectHistory?.date === item?.date && selectHistory?.title && item?.title ? "select-history" : "title-truncate:hover"}`}
                    onClick={() => {
                      setSelectHistory(item);
                      if (window.innerWidth < 1080) {
                        setSidebar(false);
                      }
                    }}>{item.title}</p>
                ))}

                {/* Previous 30 Days */}
                {history.find(item => isLast30Days(item.date)) && (
                  <p className="f-size" style={{ fontSize: "0.8rem" }}>Previous 30 Days</p>
                )}
                {history.filter(item => isLast30Days(item.date)).map((item, idx) => (
                  <p key={`last30-${idx}`} className={`title-truncate ${selectHistory?.date === item?.date && selectHistory?.title && item?.title ? "select-history" : "title-truncate:hover"}`}
                    onClick={() => {
                      setSelectHistory(item);
                      if (window.innerWidth < 1080) {
                        setSidebar(false);
                      }
                    }}
                  >{item.title}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      )
      }
    </>
  );
}

export default Sidebar;
